import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE, WHITE } from '../../../Constants/Colors.constants';

export const OnboardingSplashStyles = makeStyles((theme) => ({
  onboardingSplashContainer: {
    position: 'sticky',
    top: 0,
    background: PRIMARY_BLUE,
    width: '50%',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  onboardingStudioSplashHeader: {
    textAlign: 'center',
    marginTop: 90,

    [theme.breakpoints.down('md')]: {
      marginTop: 20,
      marginBottom: 20,
    },
  },

  onboardingStudioSplashTitle: {
    color: WHITE,
    fontSize: '22px',
    fontWeight: 'bold',
    lineHeight: '26px',
  },

  onboardingStudioSplashLogo: { marginTop: 25, width: 250 },

  onboardingStudioSplashImage: {
    zIndex: -1,
    maxHeight: '70%',
    position: 'absolute',
    bottom: 0,
    left: '3%',

    [theme.breakpoints.down('md')]: {
      display: 'block',
      margin: 'auto',
      marginTop: 30,
      position: 'unset',
      height: '400px',
    },
  },
  onbordingInnerContainer: {
    position: 'relative',
    top: 0,
    width: '100%',
    height: '100vh',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  onboardingStudioSplashImageUsc: {
    zIndex: -1,
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: 'auto',
    minHeight: '100%',
    minWidth: '100%',
    objectFit: 'cover',
  },
}));
